
export const Nut = () => {
    return(
        <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.416 3.12a1.2 1.2 0 0 0-1.042.605l-4.113 7.2a1.2 1.2 0 0 0 0 1.19l4.113 7.2a1.2 1.2 0 0 0 1.042.605h8.208a1.201 1.201 0 0 0 1.041-.605l4.115-7.2a1.2 1.2 0 0 0 0-1.19l-4.115-7.2a1.2 1.2 0 0 0-1.041-.605H7.416Zm6.021 11.635a3.599 3.599 0 1 1-3.64-6.209 3.599 3.599 0 0 1 3.64 6.21Z"></path>
        </svg>
    )
}